var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:[_vm.playState ? 'anm-' + _vm.val.animationName : ''],style:({
    position: 'absolute',
    width: _vm.val.width / 7.5 + '%',
    height: _vm.val.height / _vm.h * 100 + '%',
    left: _vm.val.left / 7.5 + '%',
    top: _vm.val.top / _vm.h * 100 + '%',
    zIndex: _vm.val.z,
    backgroundColor: _vm.val.bgColor,
    backgroundImage: 'url(' + _vm.val.backPic + ')',
    color: _vm.val.color
  }),attrs:{"contenteditable":"true"},domProps:{"innerHTML":_vm._s(_vm.val.text)},on:{"blur":function (e) { return _vm.updateText(e, _vm.val.uuid); }}})}
var staticRenderFns = []

export { render, staticRenderFns }